(ns app.products-section.views
  (:require [app.components.buttons.views :refer [icon-button]]
            [app.components.cards.views :refer [product-card]]
            [app.components.headers.views :refer [header]]
            [app.components.icons.views :refer [plus-icon]]
            [app.components.menus.views :refer [project-card-menu-component
                                                workpaces-menu]]
            [app.components.pop-ups.views :refer [mui-snackbar]]
            [app.dashboard.events :as wevents :refer [get-token]]
            [app.endpoints :refer (strive-react-endpoint)]
            [app.subs :as subs]
            [re-com.core :as re-com :refer [at h-box v-box]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reagent.core :as r]))

(def copy-link-notification (r/atom false))
(def action (r/atom :none))

(defn handle-context-menu-fn [context-menu type id menu-id]
  (fn [^js/Event e]
    (.preventDefault e)
    (when (nil? @context-menu)
      (reset! context-menu {:mouse-x (+ (.-clientX e) 2) :mouse-y (- (.-clientY e) 6) :type type :id id})
      (reset! menu-id "menu-move-to-button"))))

(defn- get-forms-background [theme_data]
  (let [json-object (.parse js/JSON (:value theme_data))
        {:keys [background_image_url]} (js->clj json-object :keywordize-keys true)]
    background_image_url))

(defn product-list [& {:keys [workspace-id selected-folder-id id product-form-secondary-id type product-form-name thumbnail link onChange copyLink sent-value last-updated product-description product-form-array delete-notification show-elipsis-menu?]}]
  (let [context-menu (r/atom nil)
        label-clicked-out? (r/atom false)
        showing-settings? (r/atom false)
        show-workspaces-menu? (r/atom false)
        workspace-data  @(re-posh/subscribe [::subs/selected-workspace-data])
        menu-id (r/atom "")
        assets-selected (r/atom '())]
    (fn []
      [:div (if show-elipsis-menu? {:onContextMenu (handle-context-menu-fn context-menu :project-card id menu-id) :style {:cursor "context-menu"}} {})

       [product-card {:product-form-name product-form-name
                      :thumbnail thumbnail
                      :onClick #((js/window.location.assign link))
                      :onChange onChange
                      :label-clicked-out? label-clicked-out?
                      :product-form-id id
                      :link link
                      :show-workspaces-menu? show-workspaces-menu?
                      :copyLink copyLink
                      :type type
                      :workspace-id workspace-id
                      :selected-folder-id selected-folder-id
                      :showing-settings? showing-settings?
                      :sent-value sent-value
                      :last-updated last-updated
                      :product-form-secondary-id product-form-secondary-id
                      :product-description product-description
                      :action action
                      :menu-id menu-id
                      :product-form-array product-form-array
                      :assets-selected assets-selected
                      :delete-notification delete-notification
                      :show-ellipsis-menu? show-elipsis-menu?}]
       [h-box :children [[project-card-menu-component menu-id link label-clicked-out? show-workspaces-menu? context-menu copyLink type
                          workspace-id selected-folder-id id product-form-name product-form-secondary-id product-description
                          action showing-settings? product-form-array assets-selected delete-notification]

                         [workpaces-menu {:menu-id menu-id :show-workspaces-menu? show-workspaces-menu? :workspace-id workspace-id
                                          :selected-folder-id selected-folder-id :workspace-data workspace-data :type type :product-form-id id
                                          :context-menu context-menu :showing-settings? showing-settings? :product-form-name product-form-name
                                          :product-form-secondary-id product-form-secondary-id :product-description product-description
                                          :action action :assets-selected assets-selected :move-notification nil}]]
        :height "24px"]])))

(defn product-link [{:keys [template_id workspace-id folder-id]}]
  (let [token (get-token)]
    (str strive-react-endpoint "/main?template_id=" template_id
         "&token=" token
         "&workspace_id=" workspace-id 
         (when-not (nil? folder-id) (str "&folder-id=" folder-id)))))

(defn form-link [{:keys [id workspace-id folder-id]}]
  (let [token (get-token)]
    (str strive-react-endpoint "/strive-forms/" id
         "?token=" token
         "&workspace_id=" workspace-id
         (when-not (nil? folder-id) (str "&folder-id=" folder-id)))))

(defn products-section [workspace-id selected-folder-id data label type create-new delete-notification]
  [v-box
   :src (at)
   :gap "20px"
   :children [[h-box :src (at)
               :gap "5px"
               :align :center
               :children [[header {:label label :type :normal :size :semibold :style {:margin-top "4px"}}]
                          [icon-button {:icon plus-icon :onClick create-new}]]]
              [h-box
               :src (at)
               :style {:flex-flow "row wrap"}
               :children [(if (= type :product)
                            (map-indexed (fn [index {:keys [name thumbnail id template_id last_send_count updated_at product_description]}]
                                           ^{:key (str "grid-product" id name)}
                                           [product-list
                                            :workspace-id workspace-id
                                            :selected-folder-id selected-folder-id
                                            :id id
                                            :product-form-secondary-id (js/parseInt template_id)
                                            :type :product
                                            :product-form-name name
                                            :thumbnail thumbnail
                                            :link (product-link {:template_id template_id :workspace-id workspace-id :folder-id selected-folder-id})
                                            :onChange #(do  (re-frame/dispatch [::wevents/update-product-name-local {:name % :products  (:selected-folder/projects data) :index index}])
                                                            (re-frame/dispatch [::wevents/update-product-name {:product-id id :name % :workspace-id workspace-id :folder-id (:selected-folder/id data)}]))
                                            :copyLink #(do (wevents/copy-link (product-link {:template_id template_id :workspace-id workspace-id :folder-id selected-folder-id}))
                                                           (reset! copy-link-notification true))
                                            :sent-value (when-not (nil? last_send_count) (str last_send_count " Emails"))
                                            :last-updated updated_at
                                            :product-description product_description
                                            :product-form-array (:selected-folder/projects data)
                                            :delete-notification delete-notification
                                            :show-elipsis-menu? true])
                                         (:selected-folder/projects data))
                            (map-indexed (fn [index {:keys [name id theme_data count updated_at form_id]}]
                                           ^{:key (str "grid" id name)}
                                           [product-list :workspace-id workspace-id
                                            :selected-folder-id selected-folder-id
                                            :id id
                                            :product-form-secondary-id form_id
                                            :type :form
                                            :product-form-name name
                                            :thumbnail (get-forms-background theme_data)
                                            :link (form-link {:id id :workspace-id workspace-id :folder-id selected-folder-id})
                                            :onChange #(do (re-frame/dispatch [::wevents/update-form-name-local {:name % :forms  (:selected-folder/forms data) :index index}])
                                                           (re-frame/dispatch [::wevents/update-form-name {:form-id id :name % :workspace-id workspace-id :folder-id (:selected-folder/id data)}]))
                                            :copyLink #(do (wevents/copy-link (form-link {:id id :workspace-id workspace-id :folder-id selected-folder-id}))
                                                           (reset! copy-link-notification true))
                                            :sent-value (when-not (nil? count) (str count " Responses"))
                                            :last-updated updated_at
                                            :product-form-array (:selected-folder/forms data)
                                            :delete-notification delete-notification
                                            :show-elipsis-menu? true])
                                         (:selected-folder/forms data)))
                          (when @copy-link-notification [mui-snackbar {:main-text "Link copied. Recipients of this link should also be given access permission." :open copy-link-notification}])]]]])

(defn deleted-products-section [workspace-id selected-folder-id data label type create-new delete-notification]
  [v-box
   :src (at)
   :gap "20px"
   :children [[h-box
               :src (at)
               :style {:flex-flow "row wrap"}
               :children [(if (= type :product)
                            (map-indexed (fn [index {:keys [name thumbnail id template_id last_send_count updated_at product_description]}]
                                           ^{:key (str id name)}
                                           [product-list
                                            :workspace-id workspace-id
                                            :selected-folder-id selected-folder-id
                                            :id id
                                            :product-form-secondary-id (js/parseInt template_id)
                                            :type :product
                                            :product-form-name name
                                            :thumbnail thumbnail
                                            :link (product-link {:template_id template_id  :workspace-id workspace-id :folder-id selected-folder-id})
                                            :onChange #(do  (re-frame/dispatch [::wevents/update-product-name-local {:name % :products  (:deleted-selected-folder/projects data) :index index}])
                                                            (re-frame/dispatch [::wevents/update-product-name {:product-id id :name % :workspace-id workspace-id :folder-id (:deleted-selected-folder/id data)}]))
                                            :copyLink #(do (wevents/copy-link (product-link {:template_id template_id :workspace-id workspace-id :folder-id selected-folder-id}))
                                                           (reset! copy-link-notification true))
                                            :sent-value (when-not (nil? last_send_count) (str last_send_count " Emails"))
                                            :last-updated updated_at
                                            :product-description product_description
                                            :product-form-array (:deleted-selected-folder/projects data)
                                            :delete-notification delete-notification
                                            :show-elipsis-menu? false])
                                         (:deleted-selected-folder/projects data))
                            (map-indexed (fn [index {:keys [name id theme_data count updated_at form_id]}]
                                           ^{:key (str id name)}
                                           [product-list :workspace-id workspace-id
                                            :selected-folder-id selected-folder-id
                                            :id id
                                            :product-form-secondary-id form_id
                                            :type :form
                                            :product-form-name name
                                            :thumbnail (get-forms-background theme_data)
                                            :link (form-link {:id id :workspace-id workspace-id :folder-id selected-folder-id})
                                            :onChange #(do (re-frame/dispatch [::wevents/update-form-name-local {:name % :forms  (:deleted-selected-folder/forms data) :index index}])
                                                           (re-frame/dispatch [::wevents/update-form-name {:form-id id :name % :workspace-id workspace-id :folder-id (:deleted-selected-folder/id data)}]))
                                            :copyLink #(do (wevents/copy-link (form-link {:id id :workspace-id workspace-id :folder-id selected-folder-id}))
                                                           (reset! copy-link-notification true))
                                            :sent-value (when-not (nil? count) (str count " Responses"))
                                            :last-updated updated_at
                                            :product-form-array (:selected-folder/forms data)
                                            :delete-notification delete-notification
                                            :show-elipsis-menu? false])
                                         (:deleted-selected-folder/forms data)))
                          (when @copy-link-notification [mui-snackbar {:main-text "Link copied. Recipients of this link should also be given access permission." :open copy-link-notification}])]]]])